import React from 'react';

import * as Collapsible from '@radix-ui/react-collapsible';

type CollapsibleProps = {
  children: React.ReactNode;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  className?: string;
};

export const CollapsibleContent = ({ children, open, onOpenChange, className }: CollapsibleProps) => {
  return (
    <Collapsible.Root onOpenChange={onOpenChange} open={open}>
      <Collapsible.Content className={className}>{children}</Collapsible.Content>
    </Collapsible.Root>
  );
};
